import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tratamiento-datos',
  templateUrl: './tratamiento-datos.component.html',
  styleUrls: ['./tratamiento-datos.component.scss']
})
export class TratamientoDatosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
